/**
 * Hook for fetching combined dashboard summary (stats + priorities + workload).
 * @module hooks
 */

import { dashboardService } from '@/services/api';
import type { DashboardSummaryData } from '@/services/api/dashboardService';
import { useDashboardQuery } from './useDashboardQuery';

interface UseDashboardSummaryReturn {
  taskStats: DashboardSummaryData['taskStats'] | null;
  priorityDistribution: DashboardSummaryData['priorityDistribution'] | null;
  totalTasks: DashboardSummaryData['totalTasks'] | null;
  teamWorkload: DashboardSummaryData['teamWorkload'] | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

const FETCHER = () => dashboardService.getSummary();

export function useDashboardSummary(): UseDashboardSummaryReturn {
  const { data, isLoading, error, refresh } =
    useDashboardQuery<DashboardSummaryData>(
      FETCHER,
      'Failed to fetch dashboard summary'
    );
  return {
    taskStats: data?.taskStats ?? null,
    priorityDistribution: data?.priorityDistribution ?? null,
    totalTasks: data?.totalTasks ?? null,
    teamWorkload: data?.teamWorkload ?? null,
    isLoading,
    error,
    refresh,
  };
}
